import React from 'react';
import {TabbedOverviewPage, UsingReportSection} from '../components/OverviewSections.comp';

// Common Section text with its own fallback copy — shown even before the
// partner has any dashboard data, like the other Introduction pages.
const AboutReportPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'What This Report Tells You',
                content: <UsingReportSection/>,
            },
        ]}
    />
);

export default AboutReportPage;
